'use client'

import { HomeContainer } from '@/components/common'
import { ETrackingEvent } from '@/lib/gtm/type'
import { useScrollTracking } from '@/lib/gtm/use-tracking-section'
import { ProductByStyleFormatter } from '@/types/product-detail'
import { useRef } from 'react'
import { ShopTheLookItem } from './shop-the-look-item'
type ContentProps = {
  data: ProductByStyleFormatter[]
  productId: string
}

export const ShopTheLooksContent: React.FC<ContentProps> = ({
  data,
  productId,
}) => {
  const ref = useRef<HTMLDivElement>(null)

  useScrollTracking({
    elementRef: ref,
    event: ETrackingEvent.ViewSuggestionStyle,
    product_id: productId,
    active: !!data?.length,
  })

  return (
    <HomeContainer data-tracking-level-2={'SuggestedProduct'}>
      <div className='mb-2 mt-10 flex items-center justify-between' ref={ref}>
        <h3 className='font-criteria text-lg font-medium uppercase text-neutral-900 lg:text-[28px] lg:leading-10'>
          Mua sắm theo phong cách
        </h3>
      </div>
      <ul className='grid grid-cols-2 gap-4 lg:grid-cols-4 lg:gap-5'>
        {data.map((item) => (
          <ShopTheLookItem key={item.slug} data={item} />
        ))}
      </ul>
    </HomeContainer>
  )
}
